/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEventDto
 */
export interface CreateEventDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEventDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateEventDto
     */
    categIds: number;
    /**
     * 
     * @type {number}
     * @memberof CreateEventDto
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof CreateEventDto
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventDto
     */
    stop: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateEventDto
     */
    partnerIds: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof CreateEventDto
     */
    partnerSelected: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEventDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventDto
     */
    location?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEventDto
     */
    contextTracking?: boolean;
}

/**
 * Check if a given object implements the CreateEventDto interface.
 */
export function instanceOfCreateEventDto(value: object): value is CreateEventDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('categIds' in value) || value['categIds'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('stop' in value) || value['stop'] === undefined) return false;
    if (!('partnerIds' in value) || value['partnerIds'] === undefined) return false;
    if (!('partnerSelected' in value) || value['partnerSelected'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function CreateEventDtoFromJSON(json: any): CreateEventDto {
    return CreateEventDtoFromJSONTyped(json, false);
}

export function CreateEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'categIds': json['categ_ids'],
        'userId': json['user_id'],
        'start': json['start'],
        'stop': json['stop'],
        'partnerIds': json['partner_ids'],
        'partnerSelected': json['partner_selected'],
        'description': json['description'],
        'location': json['location'] == null ? undefined : json['location'],
        'contextTracking': json['contextTracking'] == null ? undefined : json['contextTracking'],
    };
}

export function CreateEventDtoToJSON(json: any): CreateEventDto {
    return CreateEventDtoToJSONTyped(json, false);
}

export function CreateEventDtoToJSONTyped(value?: CreateEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'categ_ids': value['categIds'],
        'user_id': value['userId'],
        'start': value['start'],
        'stop': value['stop'],
        'partner_ids': value['partnerIds'],
        'partner_selected': value['partnerSelected'],
        'description': value['description'],
        'location': value['location'],
        'contextTracking': value['contextTracking'],
    };
}

